import type { FaireProductEntity } from "../../entity_types/product";

export const p_qq9bvd8cf3: FaireProductEntity = {
  token: "p_qq9bvd8cf3",
  type: "product",
  name: "12 Inch Saint.Francis Of Assisi",
  brandToken: "b_6clm7lye",
  brandName: "Hi-Line Gift Ltd.",
  imageUrl:
    "https://cdn.faire.com/fastly/b0cb8e74f02da2cb3b0707fe54581e2336056094bf2d539f612558d172f65316.jpeg",
  galleryImageUrls: [],
  priceDollars: 31.25,
  description:
    "This beautifully crafted St. Francis of Assisi statue captures the essence of the beloved saint, known for his deep love of nature, simplicity, and compassion for all living creatures. Depicted in a humble pose, wearing his traditional Franciscan habit. Ideal for homes or prayer spaces, this statue invites reflection on faith, kindness, and the beauty of the natural world. Made from high-quality polyresin with intricate detailing, it brings a sense of tranquility, love, and spiritual inspiration to any setting.",
  tags: [],
  msrpDollars: 68,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:32.995Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
